export const apis = {
  register: "/auth/registration",
  new_password: "/auth/registration/generate_new_password",
  sessions: "/admin/sessions",
  logout: "/admin/sessions/destroy",
  forgot_password: "/auth/registration/forgot_password", // params email
  reset_password: "/auth/registration/reset_password",
  addresses: "/addresses", // params email and authentication_token
  regions: "/fd_regions", // params email and authentication_token
  origins: "/admin/fd_origins",
  products: "/admin/products", // params email and authentication_token
  line_items: "/line_items",
  orders: "/admin/orders",
  carts: "/carts",
  admin: {
    orders: "/admin/orders",
    products: "/admin/products",
    customers: "/admin/customers",
    customer_enable: "/admin/customers/activate_portal",
    uploadImgs: "/admin/products/upload_images",
    sync_omni_users: "/admin/sync_omni_users",
    export_excel: "/admin/products/export_excel",
    import_excel: "/admin/products/import_excel",
    product_filters: "/admin/products/product_filters",
    product_delete: "/admin/products/delete_images",
    admin_marketing: "/admin/marketings",
    admins: "/admin/admins",
    admin_enable: "/admin/admins/enable",
    admin_update: "/admin/admins/update_admin",
    admin_disable: "/admin/admins/disable",
    admin_delete: "/admin/admins/destroy",
    bulk_prod_upload: "/admin/products/upload_pattern_images",
    bulk_prod_delete: "/admin/products/delete_pattern_images",
  },
  update_line_items: (id) => `/line_items/${id}/update_quntity`,
  product_filters: "/products/product_filters",
  filter_prods: "/products/filter_products",
  update_order: "/orders/update_order",
  add_comments: "/admin/orders/create_order_comment",
  get_comments: "/admin/orders/get_order_comments",
  order_history: "/orders/order_history",
  order_repeat: "/orders/repeat_order",
  dashboard: "/dash_board",
  sales_orders: "/orders/sales_orders",
  get_proforma_doc: "/orders/get_proforma_doc",
  update_sales_order_status: "/orders/update_sales_order_status",
  customer_shipments_list: "/customer_shipments_list",
  customer_payment_terms: "/customer_payment_terms",
  customer_shipment_terms: "/customer_shipment_terms",
  customer_shipment_doc: "/customer_shipment_doc",
  customer_billing_doc: "/customer_billing_doc",
  customer_billing_list: "/customer_billing_list",
  customer_shipment_track: "/customer_shipment_track",
  sync_customer_orders: "/sync_customer_orders",
  sync_customer_details: "/sync_customer_details",
  zones: "/marketings/list_country_zone",
};
